// export function formatHtmlString(stringPart) {
//   if (!stringPart) return "[]";

//   return stringPart
//     .replace(/(<([^>]+)>)/gi, " ")
//     .replace(/\n/g, "")
//     .replace(/&nbsp;/g, " ")
//     .replace(/&amp;/g, "&")
//     .replace(/ {2,}/g, " ")
//     .trim();
// }

// Characters not recognized by the tokenizer need to be replaced
// https://www.accentletters.com/
const ACCENT_LETTERS = [
  ["\u00a0\u00ad·", ""], // "\ad" = soft hyphen
  ["\u2011\u2013\u2014\u2212•⁻-", "-"], // "\xb7" = middle dot, how to handle?
  ["\u2018\u2019\u00b4\u02bb`", "'"],
  ["”“¨«»", "\""], // prettier-ignore
  ["±", "+/-"],

  ["¹", "1"],
  ["²", "2"],
  ["³", "3"],
  ["@", "at"],
  ["\u201a", ","],
  ["\u03b1", "alpha"],
  ["π", "pi"],
  ["μ", "micro"],
  ["ȧàăáãâảạā", "a"],
  ["ȦÀĂÁÃÂẢẠĀ", "A"],
  ["ćċçč", "c"],
  ["ĆĊÇČ", "C"],
  ["đðď", "d"],
  ["Ð", "D"],
  ["ëěéęêèėế", "e"],
  ["ËĔÉĘÊÈĖẾ", "E"],
  ["ﬂ", "fl"],
  ["ğġ", "g"],
  ["ĞĠ", "G"],
  ["ħȟ", "h"],
  ["íîïīìǐ\u0131", "i"],
  ["ÍÎÏĪÌǏ", "I"],
  ["ł", "l"],
  ["Ł", "L"],
  ["ṃ", "m"],
  ["Ṃ", "M"],
  ["ńñňŋ", "n"],
  ["ŃÑŇ", "N"],
  ["óôǫōõòởơ", "o"],
  ["ÓÔǪŌÕÒƠƠ", "O"],
  ["œ", "oe"],
  ["Œ", "Oe"],
  ["ß", "ss"],
  ["ŕř", "r"],
  ["ŔŘ", "R"],
  ["śṡŝšşș", "s"],
  ["ŚṠŜŠŞȘ", "S"],
  ["ţťþ", "t"],
  ["ŢŤÞ", "T"],
  ["úūüûư", "u"],
  ["ÚŪÜÛƯ", "U"],
  ["ý", "y"],
  ["Ý", "Y"],
  ["ž", "z"],
  ["Ž", "Z"],
  ["å̊", "å"],
  ["æ", "ae"],
  ["Æ", "Ae"],
  ["øő", "ö"],
  ["Ø", "Ö"],
];

const ACCENT_LETTERS_REGS = ACCENT_LETTERS.map(([accents, replaceLetter]) => [
  new RegExp(`[${accents}]`, "g"),
  replaceLetter,
]);

export function replaceAccentLetters(text: string) {
  let t = text;
  for (const [accentsReg, replaceLetter] of ACCENT_LETTERS_REGS) {
    t = t.replace(accentsReg, replaceLetter as string);
  }
  return t;
}

// Clue
// clue can contain accent chars, numbers, space, and these special chars: . , - : ; ' " ( ) & ? ! … / + # = § @
// [^a-zåäö0-9 .,:;'"()&/+=?!…#@§ëæšíïçüéèóàáø-]

// Answer
// answer can contain a-zåäö and hyphen -
// - is not valid answer char, but is extra info to some abbreviation words, e.g. vd-jobb, p-plats

export function titleToFirstName(s: string): string {
  const ns = s
    .replace(/"[^"]+"/g, "")
    .replace(/,.+$/g, "")
    .replace(/\./g, "")
    .split(/[ -]/g)
    .filter(Boolean)
    .filter((e) => !/^[a-zåäö]/.test(e)) // (von|van|de|di|la|le|del|der|el|al|ul|il|in|un|on|en|et|es|dä|äldre)
    .filter((e) => !/^(Sankt|Heliga|Kung|Prinsessan|Prins|Drottning|Moder)/.test(e));
  return ns[0] ?? "";
}

export function cleanTitleName(s: string): string {
  s = replaceAccentLetters(s.toLocaleLowerCase());
  s = s.replace(/[&]/g, " och ");
  s = s.replace(/[%]/g, " procent ");
  s = s.replace(/[,;/+=]/g, " ");
  s = s.replace(/[():"'#*!?.…]/g, "");
  s = s.replace(/^-/g, "");
  s = s.replace(/-$/g, "");
  s = s.replace(/-(?= )/g, "");
  s = s.replace(/(?<= )-/g, "");
  s = s.replace(/\s+/g, " ");
  return s;
}

export function cleanWord(w: string) {
  return replaceAccentLetters(w.replace(/^-/, "").replace(/-$/, "").toLocaleLowerCase());
}
